"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Enums_1 = require("../Enums");
var Acteur_vue_1 = __importDefault(require("./Acteur.vue"));
var ResumeProprietaire_vue_1 = __importDefault(require("./ResumeProprietaire.vue"));
var CopieProprietaire_vue_1 = __importDefault(require("./CopieProprietaire.vue"));
exports.default = {
    name: 'Proprietaire',
    components: {
        Acteur: Acteur_vue_1.default,
        ResumeProprietaire: ResumeProprietaire_vue_1.default,
        CopieProprietaire: CopieProprietaire_vue_1.default,
    },
    model: {
        prop: 'proprietaire',
    },
    props: {
        proprietaire: {
            type: Object
        },
        proprietaires: Array
    },
    data: function () {
        return {
            optionsTypePropriete: Object.keys(Enums_1.TypeDroitProprieteEnum).map(function (_) { return Enums_1.TypeDroitProprieteEnum[_]; }),
        };
    },
    methods: {
        remove: function () {
            this.$emit("remove");
        },
        edit: function () {
            this.proprietaire.NumeroPersonne = null;
        },
        getReferencedProprietaire: function (reference) {
            return this.proprietaires.find(function (_) { return _.Identifier === reference; });
        },
        getSamePersonneProprietaire: function (prop) {
            return this.proprietaires.find(function (_) { return _.NumeroPersonne === prop.NumeroPersonne && !_.References && _.Identifier !== prop.Identifier && _ != prop; });
        },
        linkProprietaire: function (proprietaire) {
            var same = this.getSamePersonneProprietaire(proprietaire);
            this.proprietaire.References = same.Identifier;
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/Proprietaire.vue
// module id = 232
// module chunks = 0